import React from "react";

function Industry() {
  return (
    <div className="project-style-one-area default-padding bg-gray blurry-shape-half-right-bottom">
      <div className="container">
        <div className="row">
          <div className="col-xl-4">
            <div className="fixed-content">
              <div className="site-heading">
                <h4 className="sub-title">Recent Projects</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Recent Projects & Innovations
                </h2>
              </div>
              <div className="project-fun-fact">
                {/* <div className="js-counter">2,650+</div> */}
                <h4>
                  Delivering scalable solutions across Blockchain, AI, and
                  Enterprise Systems
                </h4>
              </div>
            </div>
          </div>
          <div className="col-xl-8 pl-50 pl-md-15 pl-xs-15">
            <div className="project-style-one-items">
              <div className="project-style-one-item">
                <div className="thumb">
                  <img
                    src="assets/img/thumb/best_projects_01.png"
                    alt="Image Not Found"
                  />
                  <img
                    src="assets/img/shape/shape_01.png"
                    alt="Image Not Found"
                  />
                </div>
                <div className="info">
                  <div className="top">
                    <h3>Centralized Crypto Exchange</h3>

                    <p>
                      Built a high-performance trading platform with secure
                      wallet integration, real-time trading engine, and scalable
                      architecture designed for seamless user experience and
                      liquidity management.
                    </p>
                  </div>
                  <div className="bottom">
                    <a href="#" className="btn-simple">
                      Explore More <i className="fas fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="project-style-one-item">
                <div className="thumb">
                  <img
                    src="assets/img/thumb/best_projects_02.png"
                    alt="Image Not Found"
                  />
                  <img
                    src="assets/img/shape/shape_02.png"
                    alt="Image Not Found"
                  />
                </div>
                <div className="info">
                  <div className="top">
                    <h3>AI-Powered Business Agent</h3>
                    <p>
                      Developed an intelligent AI agent to automate workflows,
                      handle customer interactions, and optimize operations with
                      real-time decision-making and system integrations.
                    </p>
                  </div>
                  <div className="bottom">
                    <a href="#" className="btn-simple">
                      Explore More <i className="fas fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="project-style-one-item">
                <div className="thumb">
                  <img
                    src="assets/img/thumb/best_projects_03.png"
                    alt="Image Not Found"
                  />
                  <img
                    src="assets/img/shape/shape_03.png"
                    alt="Image Not Found"
                  />
                </div>
                <div className="info">
                  <div className="top">
                    <h3>ERP & CRM Management System</h3>
                    <p>
                      Designed a comprehensive business management platform for
                      multi-operations including sales, inventory, customer
                      management, and process automation for improved
                      efficiency.
                    </p>
                  </div>
                  <div className="bottom">
                    <a href="#" className="btn-simple">
                      Explore More <i className="fas fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Industry;
